import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash-es';
import { ApiService } from '@shared/apis';
import { SpinnerService } from '@shared/services/spinner.service';
import { finalize } from 'rxjs/operators';
import Utils from '@shared/utils/utils';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  ConcealedDamageDetailActionsComponent
} from '@routes/dialogs/concealed-damage-detail-actions/concealed-damage-detail-actions.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { GooglePlacesAutocompleteService } from '@shared/services/google-places-autocomplete.service';
import { forkJoin } from 'rxjs';
import { MasterCode } from '@shared/enums/master-code';
import Swal from 'sweetalert2';
import { AuthService } from '@core/auth/auth.service';
import Roles from '@shared/constants/roles';
import { Location } from '@angular/common';
import { ConcealedDamagePhotoComponent } from '@routes/dialogs/concealed-damage-photo/concealed-damage-photo.component';
import { environment } from '@env/environment';
import { Constants } from '@shared/constants/constants';
import {
  ConcealedDamageDetailQuestionComponent
} from '@routes/dialogs/concealed-damage-detail-question/concealed-damage-detail-question.component';
import DateUtils from '@shared/utils/date-utils';
import { FileService } from '@shared/services/file.service';
import { CD_FILE_TARGET } from '@shared/apis/concealed-damage.api';

export let FunctionList = {
  cdFunction: [
    {
      tvCode: 'TV32',
      dvdCode: 'TD32',
      dcCode: 'TC32',
      mp3Code: 'TM32',
      name: 'Picture Problem',
    }, {
      tvCode: 'TV11',
      dvdCode: 'TD11',
      dcCode: 'TC11',
      mp3Code: 'TM11',
      name: 'Functionality Problem',
    }, {
      tvCode: 'TV01',
      dvdCode: 'TD01',
      dcCode: 'TC01',
      mp3Code: 'TM01',
      name: 'Power Problem',
    }, {
      tvCode: 'TV51',
      dvdCode: 'TD53',
      dcCode: 'TC51',
      mp3Code: 'TM51',
      name: 'Sound Problem',
      type: 'TV',
    }, {
      tvCode: 'TV71',
      dvdCode: 'TD31',
      dcCode: 'TC31',
      mp3Code: 'TM71',
      name: 'NO Sound',
    }, {
      tvCode: 'TV15',
      dvdCode: 'TD15',
      dcCode: 'TC15',
      mp3Code: 'TM15',
      name: 'Other',
    }, {
      tvCode: 'TV25',
      dvdCode: 'TD32',
      dcCode: 'TC51',
      mp3Code: 'TM21',
      name: 'Display Problem',
    }, {
      tvCode: 'TNDF',
      dvdCode: 'TNDF',
      dcCode: 'TNDF',
      mp3Code: 'TNDF',
      name: 'No Defects Found',
    }, {
      tvCode: 'N/A',
      dvdCode: 'N/A',
      dcCode: 'N/A',
      mp3Code: 'N/A',
      name: 'N/A',
    }
  ]
}

export enum CdAction {
  REVIEW = 'REVIEW',
  DRAFT = 'DRAFT',
  REJECT = 'REJECT',
  PROCESS = 'PROCESS',
  PUMI = 'PUMI',
  COMPLETE = 'COMPLETE',
  DELETE = 'DELETE',
  SAVE = 'SAVE',
}

@Component({
  selector: 'app-concealed-damage-detail',
  templateUrl: './concealed-damage-detail.component.html',
  styleUrls: ['./concealed-damage-detail.component.scss']
})
export class ConcealedDamageDetailComponent implements OnInit, OnDestroy {
  readonly backend = environment.api.backend;
  readonly roles = Roles;

  userType: any;
  hasCdAgentRole = false;
  hasCdAdminRole = false;
  username: any;
  organization: string;
  isNew = false;
  isSerialEditable = false;
  isCdStoreReadOnly = false;
  creatorType: any;
  isMobile = false;
  isVerify = false;
  isSubmitted = false;
  initInfo: any;
  ticketNo = null;
  detailInfo: any;
  photos: any[] = [];
  detailForm: FormGroup;
  productTypeCode: any = '';
  isAdminViewerRole: boolean;

  addressData = {};

  productTypeOptions: any;
  fullProductTypeOptions: any;
  statusList: any;
  reportTypeOptions: any;
  customerOptions: any;
  locationAliases = [];
  returnReasonOptions: any;
  cloneReturnReasonOptions: any;
  subReasonOptions: any;
  packagingOptions: any;
  appearanceOptions: any;
  accessoryOptions: any;
  functionOptions: any;

  cloneSubReasonOptions: any;

  approvalReasonOptions: any;
  cdDefectDetails: any;
  ssDefectDetails: any;
  defectDetails: any;
  cdRejectReasons: any;
  ssRejectReasons: any;
  rejectReasons: any;

  formData: FormData;
  files: any[] = [];
  raForms: any[] = [{ fieldname: 'raForm0', file: null }];

  isCsdRejected = false;

  billingData: any;

  isDeletable = false;

  isEditable = true;

  fileFields = {
    serialOnUnit: 'serialOnUnit',
    serialOnBox: 'serialOnBox',
    frontView: 'frontView',
    backView: 'backView',
    rightSide: 'rightSide',
    leftSide: 'leftSide',
    fullViewOfScreen: 'fullViewOfScreen',
    closeUpScreen: 'closeUpScreen',
    otherImage: 'otherImage',
    frontCover: 'frontCover',
    backCover: 'backCover',
    file: 'file'
  };

  creatorTypes = {
    cd: 'cd',
    ussi: 'ussi'
  };

  showBillingData = false;

  hasRejected = false;

  dealerStoreName: any;
  reportType: any;

  lastRejectedAt: any;

  concealedDamageType: any;

  bsModalRef: BsModalRef;
  private alive = true;

  constructor(private router: Router,
              private apiService: ApiService,
              private spinnerService: SpinnerService,
              private fb: FormBuilder,
              private googlePlacesAutocomplete: GooglePlacesAutocompleteService,
              private modalService: BsModalService,
              private deviceService: DeviceDetectorService,
              private authService: AuthService,
              private location: Location,
              private fileService: FileService,
  ) {
    this.isAdminViewerRole = this.authService.checkHasAdminViewerRole();
  }

  get form(): any {
    return this.detailForm?.controls;
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
    const { userType, username, organization } = this.authService.getToken();
    this.hasCdAgentRole = this.authService.hasRole(this.roles.cdAgent) || this.authService.hasRole(this.roles.cdAdmin);
    this.hasCdAdminRole = this.authService.hasRole(this.roles.cdAdmin);
    this.showBillingData = this.hasCdAgentRole;
    this.userType = userType;
    this.username = username;
    this.organization = organization;
    const url = this.router.url.split('/');

    let last = _.last(url);
    this.isNew = last === 'new';

    this.isSerialEditable = this.serialEditable();
    if (!this.isNew) {
      this.ticketNo = last;
      this.creatorType = url[url.length - 2];
      if (this.roles.cdStore.includes(this.userType) && this.creatorType === this.creatorTypes.ussi) {
        this.isCdStoreReadOnly = true;
      }
    } else {
      this.addPhoto();
    }

    this.initInfo = {
      isNew: this.isNew,
      userType: this.userType,
      ticketNo: this.ticketNo,
      isCdStoreReadOnly: this.isCdStoreReadOnly,
    }

    if (this.isNew && Roles.ussi.includes(this.userType)) {
      this.getMyLocationAliases();
    }
    this.setFormControls();
    this.setOptions();
    this.formData = new FormData();
    this.getUserInfo(username);
  }

  ngOnDestroy() {
    this.alive = false;
  }

  getUserInfo(username) {
    this.apiService.user.getUser(username).subscribe(res => {
      this.form.firstName.setValue(res.firstName);
      this.form.lastName.setValue(res.lastName);
      this.form.email.setValue(res.username);
      this.form.cellPhone.setValue(res.tel);
    });
  }

  setOptionsByReportType(event?) {
    this.reportType = event ? event.code : this.detailInfo.reportType;
    if (this.reportType === Constants.concealedDamageReportType.CD.code) {
      this.rejectReasons = this.cdRejectReasons;
      this.defectDetails = this.cdDefectDetails;
    } else if (this.reportType === Constants.concealedDamageReportType.SS.code) {
      this.rejectReasons = this.ssRejectReasons;
      this.defectDetails = this.ssDefectDetails;
    } else {
      this.rejectReasons = [];
      this.defectDetails = [];
    }
    this.setReasonOptions(this.reportType);
  }

  setOptionsByProductType(event?) {
    if (event) {
      const productType = this.fullProductTypeOptions.find(type => type.code === event.code || type.code === event) || null;
      if (!productType) {
        this.form.productType.setValue(null);
      } else {
        this.productTypeCode = productType.code;
        this.form.productType.setValue(productType.name);
      }
    } else {
      this.form.productType.setValue(null);
    }
  }

  serialEditable() {
    if (this.isNew) {
      return true;
    }
    if (this.detailInfo) {
      if (Constants.concealedDamageStatus.DRAFT.code === this.detailInfo.status ||
        (this.hasCdAgentRole &&
          [Constants.concealedDamageStatus.REVIEW.code,
            Constants.concealedDamageStatus.DATA.code].includes(this.detailInfo.status))
      ) {
        return true;
      }
    }
    return false;
  }

  setOptions() {
    this.spinnerService.start();

    const codes = [
      MasterCode.ConcealedDamageStatus,
      MasterCode.ConcealedDamageReportTypes,
      MasterCode.ConcealedDamageReasons,
      MasterCode.ConcealedDamageSubReasons,
      MasterCode.ConcealedDamagePackages,
      MasterCode.ConcealedDamageAppearances,
      MasterCode.ConcealedDamageAccessories,
      MasterCode.ConcealedDamageRejectReasons,
      MasterCode.ConcealedDamageApprovalReasons,
      MasterCode.CDDefectDetails,
      MasterCode.SSDefectDetails,
      MasterCode.CDRejectReasons,
      MasterCode.SSRejectReasons,
      MasterCode.ConcealedDamageProductType,
    ].join(',');

    const getConstants = this.apiService.master.getCommonConstantList(codes);

    forkJoin([getConstants])
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(([resConstants]) => {
        const {
          ConcealedDamageStatus,
          ConcealedDamageReportTypes,
          ConcealedDamageReasons,
          ConcealedDamageSubReasons,
          ConcealedDamagePackages,
          ConcealedDamageAppearances,
          ConcealedDamageAccessories,
          ConcealedDamageRejectReasons,
          ConcealedDamageApprovalReasons,
          CDDefectDetails,
          SSDefectDetails,
          CDRejectReasons,
          SSRejectReasons,
          ConcealedDamageProductType,
        } = resConstants;
        this.statusList = ConcealedDamageStatus;
        this.reportTypeOptions = ConcealedDamageReportTypes;

        const productType = [];
        const existsNames = new Set();
        ConcealedDamageProductType.forEach(item => {
          if (!existsNames.has(item.name)) {
            existsNames.add(item.name);
            productType.push(item);
          }
        });

        this.productTypeOptions = productType;
        this.fullProductTypeOptions = ConcealedDamageProductType;
        this.cloneReturnReasonOptions = ConcealedDamageReasons.map(code => {
          return {
            code: code.code,
            name: code.code === 'N/A' ? code.code : `[${ code.code }] ${ code.name }`,
            reportType: code.reportType,
          }
        });
        this.cloneSubReasonOptions = _.cloneDeep(ConcealedDamageSubReasons).map(code => {
          return {
            code: code.code,
            name: code.code === 'N/A' ? code.code : `[${ code.code }] ${ code.name }`,
            reason: code.reason,
            reportType: code.reportType,
          }
        });
        this.packagingOptions = ConcealedDamagePackages.map(code => {
          return {
            code: code.code,
            name: code.code === 'N/A' ? code.code : `[${ code.code }] ${ code.name }`
          }
        });
        this.appearanceOptions = ConcealedDamageAppearances.map(code => {
          return {
            code: code.code,
            name: code.code === 'N/A' ? code.code : `[${ code.code }] ${ code.name }`
          }
        });
        this.accessoryOptions = ConcealedDamageAccessories.map(code => {
          return {
            code: code.code,
            name: code.code === 'N/A' ? code.code : `[${ code.code }] ${ code.name }`
          }
        });
        // this.rejectReasonOptions = ConcealedDamageRejectReasons.map(code => {
        //           return {
        //             code: code.code,
        //             name: `${code.code} ${code.name}`
        //           }
        //         });
        this.approvalReasonOptions = ConcealedDamageApprovalReasons.map(code => {
          return {
            code: code.code,
            name: code.code === 'N/A' ? code.code : `[${ code.code }] ${ code.name }`
          }
        });
        this.cdDefectDetails = CDDefectDetails;
        this.ssDefectDetails = SSDefectDetails;
        this.cdRejectReasons = CDRejectReasons;
        this.ssRejectReasons = SSRejectReasons;
        this.setFunctionOptions('01');
        if (this.userType === Constants.userType.dealer) {
          this.setReportTypeOptions(ConcealedDamageReportTypes);
        }
        if (!this.isNew) {
          this.getConcealedDamage();
        }
      })
  }

  setFormControls() {
    const userTypeDisable = (this.roles.cdCreator.includes(this.userType)
      || this.roles.cdReviewer.includes(this.userType))
    || this.hasCdAgentRole ? null : {
      value: null,
      disabled: true
    };

    let defaultControls = {
      ticketNo: null,
      status: null,
      serialNo: [null, Validators.compose([Validators.required, Validators.pattern(/^[A-Z-a-z0-9]*$/)])],
      modelCode: [null, Validators.compose([Validators.required, Validators.pattern(/^[A-Z-a-z0-9/]*$/)])],
      categoryIdNum: null,
      productName: null,
      requestAt: null,
      requestBy: null,
      updateAt: null,
      updateBy: null,
      approvedAt: null,
      approvedBy: null,
      raApprovedAt: null,
      raApprovedBy: null,
      reportType: [userTypeDisable, Validators.required],
      symptom: [userTypeDisable, Validators.required],
      photos: [],
      attachments: [],
      approvalComment: null,
      rejectComment: null,
      purchase: null,
      raResult: null,
      creationType: null,
      rejectionReason: null,
      salesOrderNo: { value: null, disabled: false },
      salesOrg: { value: null, disabled: false },
      soldToPartyCode: null,
      soldToPartyName: { value: null, disabled: false },
      payerPartyCode: null,
      billToPartyCode: null,
      shipToPartyCode: null,
      shipToPartyName: null,
      shipToStreet: null,
      shipToDistrict: null,
      shipToPostalCode: null,
      shipToCity: null,
      shipToCountry: null,
      shipToRegion: null,
      shipToTel: null,
      shipToEmail: [null, Validators.email],
      purchaseDate: { value: null, disabled: false },
      billingType: { value: null, disabled: false },
      billingDate: { value: null, disabled: false },
      distributionChannel: { value: null, disabled: false },
      distributionChannelName: { value: null, disabled: false },
      division: { value: null, disabled: false },
      divisionName: { value: null, disabled: false },
      poNo: null,
      poDate: null,
      reqDeliDate: null,
      remark: null,
      materialNo: { value: null, disabled: false },
      customerPo: null,
      unitPrice: null,
      movingAveragePrice: null,
      productType: [null, Validators.required],
    };

    const ussiFormControls = {
      customer: [userTypeDisable, Validators.required],
      contactEmail: [userTypeDisable, Validators.compose([Validators.required, Validators.email])],
      packaging: [userTypeDisable, Validators.required],
      appearance: null,
      accessory: [userTypeDisable, Validators.required],
      func: null,
      defectDetails: [userTypeDisable, Validators.required],
      panelUsageHours: [userTypeDisable, Validators.required],
    };

    const cdFormControls = {
      firstName: [userTypeDisable, Validators.required],
      lastName: [userTypeDisable, Validators.required],
      cellPhone: [userTypeDisable, Validators.compose([Validators.required, Validators.pattern(/\d{3}\d{3}\d{4}/g)])],
      email: [userTypeDisable, Validators.compose([Validators.required, Validators.email])],
      address: {
        address1: null,
        address2: null,
        city: null,
        state: null,
        zipcode: null,
        country: null,
        county: null,
      },
      panelUsageHours: [userTypeDisable, Validators.required],
    };

    const agentFormControls = {
      returnReason: null,
      subReason: null,
      defectDetails: null,
    };

    switch (true) {
      case this.roles.ussi.includes(this.userType):
        defaultControls = { ...defaultControls, ...ussiFormControls };
        break;
      case this.roles.dealer.includes(this.userType):
        if (this.isNew || this.creatorType === this.creatorTypes.cd) {
          defaultControls = { ...defaultControls, ...cdFormControls };
        } else {
          defaultControls = { ...defaultControls, ...ussiFormControls };
        }
        break;
      case this.roles.agent.includes(this.userType):
      case this.roles.admin.includes(this.userType):
        defaultControls = { ...defaultControls, ...agentFormControls };
        if (this.creatorType === this.creatorTypes.cd) {
          defaultControls = { ...defaultControls, ...cdFormControls };
        } else {
          defaultControls = { ...defaultControls, ...ussiFormControls };
        }
        break;
      default:
        break;
    }

    this.detailForm = this.fb.group(defaultControls);

    this.form.serialNo.valueChanges.subscribe(sn => {
      this.isVerify = false;
    });
    this.form.modelCode.valueChanges.subscribe(mc => {
      this.isVerify = false;
    });
  }

  getConcealedDamage() {
    this.isSubmitted = false;
    this.spinnerService.start();
    this.apiService.concealedDamage.getConcealedDamage(this.ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        const [statusName] = this.statusList.filter(f => f.code === res.status);
        this.detailInfo = res;

        const {
          photos,
          attachments,
          address,
          status,
          raForms,
          dealerStoreName,
          reportType,
          reviewResults
        } = this.detailInfo;

        this.photos = _.cloneDeep(photos);
        this.raForms = raForms && raForms.length > 0 ? _.cloneDeep(raForms) : [{ fieldname: 'raForm0', file: null }];
        this.dealerStoreName = dealerStoreName;
        this.reportType = reportType;
        if (reviewResults && reviewResults.length > 0) {
          const rejectResults = reviewResults.filter(rr => rr.reviewResult === 'REJECT')?.sort((r1, r2) => r1.reviewedAt > r2.reviewedAt ? -1 : 1);
          if (rejectResults && rejectResults.length > 0) {
            const lastReject = rejectResults[0];
            this.lastRejectedAt = lastReject.reviewedAt;
            this.initInfo = {
              ...this.initInfo,
              lastRejectedAt: this.lastRejectedAt,
            }
          }
        }

        if (attachments.length) {
          this.files = _.cloneDeep(this.detailInfo?.attachments);
        }

        this.detailInfo.statusName = statusName.name;
        this.initInfo.status = status;
        this.addressData = { address };
        this.isCsdRejected = status === Constants.concealedDamageStatus.CSD_REJECT.code;

        this.getMyLocationAliases(this.detailInfo.auth.createdBy.username);
        this.setFunctionOptions(this.detailInfo.categoryIdNum);
        this.setReasonOptions(this.detailInfo.reportType);
        this.setOptionsByReportType();

        Object.keys(this.detailForm.controls).forEach(key => {
          this.detailForm.controls[key].setValue(Utils.stringToNull(this.detailInfo[key]) || '');
          if (key === 'returnReason') {
            const e = {
              code: this.detailInfo[key]
            }
            this.changeReason(e);
          }
          if (key === 'cellPhone') {
            this.detailForm.controls[key].setErrors(null);
          }
        });
        this.isVerify = true;
        if (['PROCESS', 'APPROVE', 'RA-REJECT', 'COMPLETE'].includes(status)) {
          this.detailForm.disable();
        } else if (this.detailForm.disabled) {
          this.detailForm.enable();
        }
        this.setOptionsByProductType(this.detailInfo['productType'])
        this.isSerialEditable = this.serialEditable();
        this.setBillingData(
          this.detailInfo.serialNo,
          this.detailInfo.modelCode,
          this.detailInfo.billingData || null,
          this.detailInfo.billingDataInput || null);
        this.setDeletable();
        this.setEditable(status);


        /**
         *
         */
        // console.log('STATUS =', status);
        // console.log('this.isNew =', this.isNew);
        // console.log('this.isEditable =', this.isEditable);
        // console.log('this.isReadOnly =', this.isCdStoreReadOnly);
        // console.log('this.isCsdRejected =', this.isCsdRejected);
        // console.log('this.isDeletable =', this.isDeletable);
        // console.log('this.isSerialEditable =', this.isSerialEditable);
      }, err => Utils.showError(err));
  }

  hasRejectedHistory() {
    return this.detailInfo?.reviewResults?.filter(reviewResult => reviewResult.reviewResult === 'REJECT').length > 0;
  }

  setDeletable() {
    const hasRejectedHistory = this.hasRejectedHistory();
    if (!this.isNew &&
      (
        (['DRAFT', 'DATA', 'REVIEW'].includes(this.detailInfo?.status) && this.roles.cdCreator.includes(this.userType) && !this.isCdStoreReadOnly && !hasRejectedHistory) ||
        (['REJECT', 'PROCESS', 'APPROVE', 'RA-REJECT', 'COMPLETE'].includes(this.detailInfo?.status) && this.hasCdAgentRole)
      )
    ) {
      this.isDeletable = true;
    }
  }

  isPhotoDeletable() {
    let isPhotoDeletable = false;
    const hasRejectedHistory = this.hasRejectedHistory();
    if (this.roles.cdCreator.includes(this.userType) && !this.isCdStoreReadOnly && ['DRAFT', 'DATA', 'REJECT'].includes(this.detailInfo?.status)) {
      isPhotoDeletable = true;
    }
    if ((this.roles.cdReviewer.includes(this.userType) && ['REVIEW', 'REJECT'].includes(this.detailInfo?.status)) ||
      (this.roles.cdReviewer.includes(this.userType) && ['DRAFT'].includes(this.detailInfo?.status) && hasRejectedHistory)
    ) {
      isPhotoDeletable = true;
    }
    return isPhotoDeletable;
  }

  isAttachFileDeletable() {
    return this.roles.cdReviewer.includes(this.userType) && ['REVIEW'].includes(this.detailInfo?.status);
  }

  isRaFormDeletable() {
    return (this.roles.cdReviewer.includes(this.userType) || this.hasCdAdminRole) && ['APPROVE'].includes(this.detailInfo?.status);
  }

  setEditable(status) {
    if (['PROCESS', 'APPROVE', 'RA-REJECT', 'COMPLETE'].includes(status)) {
      this.isEditable = false;
    } else {
      const hasRejectedHistory = this.hasRejectedHistory();
      if (['REVIEW'].includes(status) && this.roles.cdCreator.includes(this.userType)) {
        this.isEditable = false;
      } else {
        if (['REJECT', 'DRAFT'].includes(status) && this.roles.cdCreator.includes(this.userType) && hasRejectedHistory) {
          this.isEditable = false;
        } else {
          this.isEditable = true;
        }
      }
    }
  }

  getMyLocationAliases(username?) {
    const name = username || this.username;
    this.apiService.user.getMyLocationAliases(name)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.locationAliases = res;
        this.customerOptions = res.map(m => {
          return {
            code: m._id,
            name: m.locationAlias,
            email: m.email,
            concealedDamageType: m.concealedDamageType,
          };
        });
        if (this.customerOptions && this.customerOptions.length > 0 && this.isNew) {
          this.form.customer.setValue(this.customerOptions[0].code || null);
          this.form.contactEmail.setValue(this.customerOptions[0].email || null);
        }
      }, err => Utils.showError(err));
  }

  openPhotoDetail(event, fieldName) {
    const photo = this.photos.find(photo => photo.fieldname === fieldName);
    let initialState: any = {
      initInfo: this.initInfo,
      fileInfo: { ...photo, fieldName }
    };
    this.bsModalRef = this.modalService.show(ConcealedDamagePhotoComponent, { initialState });
    this.bsModalRef.content.onClose.subscribe(result => {
      photo.comment = result.comment;
    });
  }

  loadingScanner(event) {
    event.stopPropagation();
    event.preventDefault();
    const scannerGuideSize = this.isMobile ? { width: 280, height: 80 } : { width: 400, height: 100 };
    let html5QrcodeScanner = new Html5QrcodeScanner('reader', { fps: 10, qrbox: scannerGuideSize }, false);

    const onScanSuccess = (decodedText?, decodedResult?) => {
      //Sample Scanned Text from Samsung QR: https://www.samsung.com/qrservice/?SN=0J477DCT300331K&MC=NE63A6111SS/AC
      let serialNo;
      if (decodedText.includes('http')) {
        //decodedText = https://www.samsung.com/qrservice/?SN=0J477DCT300331K&MC=NE63A6111SS/AC
        const queryStringArray = decodedText.substring(decodedText.indexOf('?') + 1, decodedText.length).split('&');
        //queryStringArray = ['SN=0J477DCT300331K', 'MC=NE63A6111SS/AC']
        const snItem = queryStringArray.find(qs => qs.includes('SN'));
        //snItem = 'SN=0J477DCT300331K'
        if (snItem) {
          serialNo = snItem.substring(snItem.indexOf('=') + 1, snItem.length);
        }
      } else {
        serialNo = decodedText;
      }
      this.form.serialNo.setValue(serialNo);
      html5QrcodeScanner.clear();
    }
    // @ts-ignore
    html5QrcodeScanner.render(onScanSuccess);
  }

  setFunctionOptions(categoryIdNum) {
    categoryIdNum = '01'; //2023-03-22 현업 요청으로 무조건 TV의 Function이 나오도록 수정
    let fieldType;
    switch (true) {
      case ['01', '02', '05', '07', '08', '12', 'A2'].includes(categoryIdNum):
        fieldType = 'tv';
        break;
      case ['13', '14', '15'].includes(categoryIdNum):
        fieldType = 'dvd';
        break;
      case ['22'].includes(categoryIdNum):
        fieldType = 'dc';
        break;
      case ['06'].includes(categoryIdNum):
        fieldType = 'mp3';
        break;
      default:
        fieldType = 'na';
        break;
    }

    if (fieldType === 'na') {
      this.functionOptions = [{
        code: 'N/A',
        name: 'N/A'
      }];
      return;
    }

    const filterCode = fieldType.concat('Code');
    this.functionOptions = FunctionList.cdFunction.map(m => {
      return {
        code: m[filterCode],
        name: m[filterCode] === 'N/A' ? m[filterCode] : `[${ m[filterCode] }] ${ m.name }`
      }
    });
  }

  setReasonOptions(reportType) {
    this.returnReasonOptions = this.cloneReturnReasonOptions.filter(rr => rr.reportType.includes(reportType));
    this.subReasonOptions = [];
    if (this.form.returnReason) {
      this.form.returnReason.setValue(null);
    }
    if (this.form.subReason) {
      this.form.subReason.setValue(null);
    }
  }

  setReportTypeOptions(concealedDamageReportTypes: any[]) {
    this.apiService.dealer.getDealer(this.organization).subscribe(response => {
      const { concealedDamageType } = response;
      if (this.isNew && this.roles.cdStore.includes(this.userType)) {
        if (concealedDamageType === Constants.concealedTypeType.SELF_INSPECTION.code) {
          this.reportTypeOptions = concealedDamageReportTypes.filter(rt => rt.code === Constants.concealedDamageReportType.CD.code);
        } else if (concealedDamageType === Constants.concealedTypeType.SAMSUNG_INSPECTION.code) {
          this.reportTypeOptions = concealedDamageReportTypes.filter(rt => rt.code === Constants.concealedDamageReportType.SS.code);
        } else if (concealedDamageType === Constants.concealedTypeType.SELF_SAMSUNG.code) {
          this.reportTypeOptions = concealedDamageReportTypes;
        } else {
          this.reportTypeOptions = [];
          Utils.showError('Not support RA Request Type', 'Not support RA Request Type');
        }
      } else {
        this.reportTypeOptions = concealedDamageReportTypes;
      }
    })
  }

  unverify(event) {
    this.isVerify = false;
  }

  serialVerify($event) {
    $event.stopPropagation();
    $event.preventDefault();

    this.isVerify = false;
    const serialNo = this.form.serialNo.value;
    this.form.modelCode.setValue(null);
    // if (!this.hasCdAgentRole) {
    this.setBillingData();
    // }
    this.spinnerService.start();
    this.apiService.concealedDamage.getCheckSerial(serialNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        let { categoryIdNum, modelCode, productName, billingData } = res;
        this.form.serialNo.setValue(serialNo.toUpperCase());
        this.form.categoryIdNum.setValue(categoryIdNum);
        this.form.modelCode.setValue(modelCode);
        this.form.productName.setValue(productName);
        this.setOptionsByProductType(res.categoryIdNum);
        this.isVerify = true;
        this.setFunctionOptions(categoryIdNum);
        if (!billingData) {
          Swal.fire({
            title: 'Serial can’t be found in the system. Do you want to proceed anyway?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            icon: 'question',
          }).then((result) => {
            if (result.isConfirmed) {
              // if (!this.hasCdAgentRole) {
              this.setBillingData(serialNo, modelCode, billingData);
              // }
            } else if (result.isDenied) {
              Swal.fire('Canceled!', '', 'info');
            }
          });
        } else {
          // if (!this.hasCdAgentRole) {
          this.setBillingData(serialNo, modelCode, billingData);
          // }
        }

      }, err => Utils.showError(err));
  }

  setBillingData(serialNo?, modelCode?, billingData?, billingDataInput?,) {
    this.billingData = billingData;
    let salesOrderNo;
    let salesOrg;
    let soldToPartyCode;
    let soldToPartyName;
    let payerPartyCode;
    let billToPartyCode;
    let shipToPartyCode;
    let shipToPartyName;
    let shipToStreet;
    let shipToDistrict;
    let shipToPostalCode;
    let shipToCity;
    let shipToCountry;
    let shipToRegion;
    let shipToTel;
    let shipToEmail;
    let purchaseDate;
    let billingType;
    let billingDate;
    let distributionChannel;
    let distributionChannelName;
    let division;
    let divisionName;
    let poNo;
    let poDate;
    let reqDeliDate;
    let remark;
    let materialNo;
    let unitPrice;
    let movingAveragePrice;

    if (billingDataInput && billingDataInput.salesOrderNo) {
      salesOrderNo = billingDataInput.salesOrderNo;
      salesOrg = billingDataInput.salesOrg;
      soldToPartyCode = billingDataInput.soldToPartyCode;
      soldToPartyName = billingDataInput.soldToPartyName;
      payerPartyCode = billingDataInput.payerPartyCode;
      billToPartyCode = billingDataInput.billToPartyCode;
      shipToPartyCode = billingDataInput.shipToPartyCode;
      shipToPartyName = billingDataInput.shipToPartyName;
      shipToStreet = billingDataInput.shipToStreet;
      shipToDistrict = billingDataInput.shipToDistrict;
      shipToPostalCode = billingDataInput.shipToPostalCode;
      shipToCity = billingDataInput.shipToCity;
      shipToCountry = billingDataInput.shipToCountry;
      shipToRegion = billingDataInput.shipToRegion;
      shipToTel = billingDataInput.shipToTel;
      shipToEmail = billingDataInput.shipToEmail;
      purchaseDate = billingDataInput.purchaseDate;
      billingType = billingDataInput.billingType;
      billingDate = billingDataInput.billingDate;
      distributionChannel = billingDataInput.distributionChannel;
      distributionChannelName = billingDataInput.distributionChannelName;
      division = billingDataInput.division;
      divisionName = billingDataInput.divisionName;
      poNo = billingDataInput.poNo;
      poDate = billingDataInput.poDate;
      reqDeliDate = billingDataInput.reqDeliDate;
      remark = billingDataInput.remark;
      materialNo = billingDataInput.materialNo;
      unitPrice = billingDataInput.unitPrice;
      movingAveragePrice = billingDataInput.movingAveragePrice;
    } else {
      if (billingData && billingData?.headerEx?.length > 0 && billingData?.itemsEx?.length > 0 && billingData?.partnersEx?.length > 0) {
        const headerEx = billingData.headerEx.sort((a, b) => (a.FKDAT > b.FKDAT ? -1 : 1))[0];
        const item = billingData.itemsEx.find(i => i.MATNR === modelCode);
        const partners = billingData.partnersEx;
        const soldToParty = partners.find(partner => partner.PARVW === 'AG');
        const shipToParty = partners.find(partner => partner.PARVW === 'WE');
        const billToParty = partners.find(partner => partner.PARVW === 'RE');
        const payerParty = partners.find(partner => partner.PARVW === 'RG');

        salesOrderNo = item.AUBEL;
        salesOrg = headerEx.VKORG;
        soldToPartyCode = soldToParty.KUNNR;
        soldToPartyName = `${ soldToParty.NAME1 }, ${ this.buildAddress(soldToParty) }`;
        payerPartyCode = payerParty.KUNNR;
        billToPartyCode = billToParty.KUNNR;
        shipToPartyCode = shipToParty.KUNNR;
        shipToPartyName = shipToParty.NAME1;
        shipToStreet = shipToParty.STREET;
        shipToDistrict = shipToParty.CITY2;
        shipToPostalCode = shipToParty.POST_CODE1;
        shipToCity = shipToParty.CITY1;
        shipToCountry = shipToParty.COUNTRY;
        shipToRegion = shipToParty.REGION;
        shipToTel = shipToParty.TEL_NUMBER;
        shipToEmail = shipToParty.EMAIL;
        purchaseDate = DateUtils.localDate(DateUtils.stringToDate(item.PRSDT, 'YYYYMMDD'));
        billingType = headerEx.FKART;
        billingDate = DateUtils.localDate(DateUtils.stringToDate(headerEx.FKDAT, 'YYYYMMDD'));
        distributionChannel = headerEx.VTWEG;
        distributionChannelName = headerEx.VTWEG_T;
        division = headerEx.SPART;
        divisionName = headerEx.SPART_T;
        poNo = serialNo ? `CD_${ serialNo }_${ DateUtils.dateFormat(new Date(), 'MMDDYYYY') }` : null;
        poDate = serialNo ? DateUtils.dateFormat(new Date(), 'YYYYMMDD') : null;
        reqDeliDate = null;
        remark = serialNo ? `${ this.reportType }_${ this.dealerStoreName }_${ DateUtils.dateFormat(new Date(), 'MMDDYYYY') }_INSPECTED 1 APPROVED 1 REJECTED 0` : null;
        materialNo = item.MATNR;
        unitPrice = item.FKNET;
        movingAveragePrice = item.VERPR;
      } else {
        salesOrderNo = null;
        salesOrg = null;
        soldToPartyCode = null;
        soldToPartyName = null;
        payerPartyCode = null;
        billToPartyCode = null;
        shipToPartyCode = null;
        shipToPartyName = null;
        shipToStreet = null;
        shipToDistrict = null;
        shipToPostalCode = null;
        shipToCity = null;
        shipToCountry = null;
        shipToRegion = null;
        shipToTel = null;
        shipToEmail = null;
        purchaseDate = null;
        billingType = null;
        billingDate = null;
        distributionChannel = null;
        distributionChannelName = null;
        division = null;
        divisionName = null;
        poNo = null;
        poDate = null;
        reqDeliDate = null;
        remark = null;
        materialNo = null;
        unitPrice = null;
        movingAveragePrice = null;
      }
    }
    if (billingDataInput && billingDataInput.poNo) {
      poNo = billingDataInput.poNo;
      poDate = billingDataInput.poDate;
      reqDeliDate = billingDataInput.reqDeliDate;
      remark = billingDataInput.remark;
    }
    this.form.salesOrderNo.setValue(salesOrderNo);
    this.form.salesOrg.setValue(salesOrg);
    this.form.soldToPartyCode.setValue(soldToPartyCode);
    this.form.soldToPartyName.setValue(soldToPartyName);
    this.form.payerPartyCode.setValue(payerPartyCode);
    this.form.billToPartyCode.setValue(billToPartyCode);
    this.form.shipToPartyCode.setValue(shipToPartyCode);
    this.form.shipToPartyName.setValue(shipToPartyName);
    this.form.shipToStreet.setValue(shipToStreet);
    this.form.shipToDistrict.setValue(shipToDistrict);
    this.form.shipToPostalCode.setValue(shipToPostalCode);
    this.form.shipToCity.setValue(shipToCity);
    this.form.shipToCountry.setValue(shipToCountry);
    this.form.shipToRegion.setValue(shipToRegion);
    this.form.shipToTel.setValue(shipToTel);
    this.form.shipToEmail.setValue(shipToEmail);
    this.form.purchaseDate.setValue(purchaseDate);
    this.form.billingType.setValue(billingType);
    this.form.billingDate.setValue(billingDate);
    this.form.distributionChannel.setValue(distributionChannel);
    this.form.distributionChannelName.setValue(distributionChannelName);
    this.form.division.setValue(division);
    this.form.divisionName.setValue(divisionName);
    this.form.poNo.setValue(poNo);
    this.form.poDate.setValue(poDate);
    this.form.reqDeliDate.setValue(reqDeliDate);
    this.form.remark.setValue(remark);
    this.form.materialNo.setValue(materialNo);
    this.form.unitPrice.setValue(unitPrice);
    this.form.movingAveragePrice.setValue(movingAveragePrice);
  }

  buildAddress(partner) {
    let address = '';
    if (!Utils.isEmptyString(partner.STREET)) {
      address = partner.STREET;
    }
    if (!Utils.isEmptyString(partner.CITY1)) {
      address = `${ address }${ Utils.isEmptyString(address) ? '' : ', ' }${ partner.CITY1 }`;
    }
    if (!Utils.isEmptyString(partner.REGION)) {
      address = `${ address }${ Utils.isEmptyString(address) ? '' : ', ' }${ partner.REGION }`;
    }
    if (!Utils.isEmptyString(partner.POST_CODE1)) {
      address = `${ address }${ Utils.isEmptyString(address) ? '' : ', ' }${ partner.POST_CODE1 }`;
    }
    return address;
  }

  fileSelected(event, fieldName) {
    const file = event;
    this.formData.append(fieldName, file, file.name);
  }

  fileDelete(event, fieldName) {
    for (let [key, value] of Array.from(this.formData.entries())) {
      if (key === fieldName) {
        this.formData.delete(key);
        if (fieldName.includes('file')) {
          this.files = this.files.filter(f => f !== fieldName);
        }
        break;
      }
    }
  }

  addFile(event) {
    event.stopPropagation();
    event.preventDefault();
    const fileFieldName = !this.files[0]?.file ? 'file0'
      : 'file' + (parseInt(this.files.sort((a, b) => a.fieldname.localeCompare(b.fieldname, undefined, { numeric: true })).at(-1).fieldname.slice(-1)) + 1);
    this.files.push({ fieldname: fileFieldName, file: null });
  }

  addRaFrom(event) {
    event.stopPropagation();
    event.preventDefault();
    const fileFieldName = !this.raForms[0]?.file ? 'form0'
      : 'form' + (parseInt(this.raForms.sort((a, b) => a.fieldname.localeCompare(b.fieldname, undefined, { numeric: true })).at(-1).fieldname.slice(-1)) + 1);
    this.raForms.push({ fieldname: fileFieldName, file: null });
  }

  addPhoto(event?) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    let photoCount = 0;
    for (let photo of this.photos) {
      if (!photo.file) {
        const fileData = this.formData.get(photo.fieldname);
        if (fileData === null) {
          return;
        }
      }
      photoCount++;
    }
    const fileFieldName = 'Photo' + photoCount;
    this.photos.push({ fieldname: fileFieldName, file: null });
  }

  changeReason(event) {
    this.form.subReason.setValue(null);
    this.subReasonOptions = this.cloneSubReasonOptions.filter(f => f.reason === event?.code && f.reportType.includes(this.reportType));
  }

  download(raForm) {
    const { fieldname, file } = raForm;
    const url = this.apiService.concealedDamage.fileUrl(file, 'attachment');
    this.fileService.downloadFile(url, fieldname);
  }

  changeCustomer(event) {
    this.form.contactEmail.setValue(event?.email || null);
  }

  selectImg(file, fieldName) {
    const formData: FormData = new FormData();
    formData.append(fieldName, file, file.name);
    this.apiService.concealedDamage.fileUpload(this.ticketNo, CD_FILE_TARGET.PHOTO, formData)
      .subscribe(event => {
        if (event.body) {
          this.photos = _.cloneDeep(event.body);
        }
      }, err => {
        Utils.showError(err);
      });
  }

  deleteImg(fieldName) {
    Swal.fire({
      title: 'Picture will be deleted. Do you want to continue',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        const photo = this.photos.find(photo => photo.fieldname === fieldName);
        const data = {
          fileTarget: CD_FILE_TARGET.PHOTO,
          fieldname: fieldName,
          key: photo.file.key,
        }
        this.spinnerService.start();
        this.apiService.concealedDamage.deleteFile(this.ticketNo, data)
          .pipe(finalize(() => this.spinnerService.stop()))
          .subscribe(res => {
            const photos = this.photos.filter(photo => photo.fieldname !== fieldName);
            this.photos = _.cloneDeep(photos);
          }, err => Utils.showError(err));
      } else if (result.isDenied) {
        // Swal.fire('Canceled!', '', 'info');
      }
    });
  }

  async selectAttachFile(files, file) {
    const { fieldname } = file;
    for (const [index, value] of Array.from(files).entries()) {
      const f = value as File;
      const formData: FormData = new FormData();
      formData.append('file' + (parseInt(fieldname.slice(-1)) + index), f, f.name);
      await this.fileUpload(index, CD_FILE_TARGET.FILE, formData);
    }
  }

  async selectRaForm(files, file) {
    const { fieldname } = file;
    for (const [index, value] of Array.from(files).entries()) {
      const f = value as File;
      const formData: FormData = new FormData();
      formData.append('raForm0', f, f.name);
      await this.fileUpload(index, CD_FILE_TARGET.RAFORM, formData);
    }
  }

  fileUpload(index, targetType, formData) {
    return new Promise((resolve, reject) => {
      this.apiService.concealedDamage.fileUpload(this.ticketNo, targetType, formData)
        .subscribe(event => {
          if (event.body) {
            resolve(event.body);
          }
        }, err => {
          Utils.showError(err);
          reject();
        });
    }).then((data: any) => {
      switch (targetType) {
        case CD_FILE_TARGET.FILE:
          this.files = data;
          break;
        case CD_FILE_TARGET.RAFORM:
          this.raForms = data;
          break;
        default:
          break;
      }
    });
  }

  deleteAttachFile(file, i) {
    const data = {
      fileTarget: CD_FILE_TARGET.FILE,
      fieldname: file.fieldname,
      key: file.file.key,
    }
    this.spinnerService.start();
    this.apiService.concealedDamage.deleteFile(this.ticketNo, data)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        _.pullAt(this.files, i);
      }, err => Utils.showError(err));
  }

  deleteRaFromFile(file, i) {
    const data = {
      fileTarget: CD_FILE_TARGET.RAFORM,
      fieldname: file.fieldname,
      key: file.file.key,
    }
    this.spinnerService.start();
    this.apiService.concealedDamage.deleteFile(this.ticketNo, data)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        this.raForms = [{ fieldname: 'raForm0', file: null }];
      }, err => Utils.showError(err));
  }

  valueRedefinition(value) {
    value = {
      ...value, address: {
        address1: (document.getElementById('edit_route') as HTMLInputElement).value,
        address2: (document.getElementById('edit_address2') as HTMLInputElement).value,
        city: (document.getElementById('edit_locality') as HTMLInputElement).value,
        state: (document.getElementById('edit_administrative_area_level_1') as HTMLInputElement).value,
        zipcode: (document.getElementById('edit_postal_code') as HTMLInputElement).value,
        country: (document.getElementById('edit_country') as HTMLInputElement).value,
      }
    };
    return value;
  }

  getSaveDefaultData(action?) {
    const status = action === CdAction.REVIEW ? 'REVIEW' : 'DRAFT';
    this.isSubmitted = true;
    let detailData = this.detailForm.getRawValue();
    let data: any = {
      status,
      serialNo: detailData.serialNo.toUpperCase(),
      modelCode: detailData.modelCode.toUpperCase(),
      reportType: detailData.reportType,
      productType: this.productTypeCode,
      symptom: detailData.symptom,
      categoryIdNum: detailData.categoryIdNum,
      productName: detailData.productName,
      defectDetails: detailData.defectDetails,
      panelUsageHours: detailData.panelUsageHours,
      rejectionReason: detailData.rejectionReason,
      creationType: this.isNew ? this.userType : detailData.creationType,
      customerPo: detailData.customerPo || '',
      billingData: this.billingData,
    };
    if (detailData.ticketNo) {
      let billingDataInput: any = {
        salesOrderNo: detailData.salesOrderNo,
        salesOrg: detailData.salesOrg,
        soldToPartyCode: detailData.soldToPartyCode,
        soldToPartyName: detailData.soldToPartyName,
        payerPartyCode: detailData.payerPartyCode,
        billToPartyCode: detailData.billToPartyCode,
        shipToPartyCode: detailData.shipToPartyCode,
        shipToPartyName: detailData.shipToPartyName,
        shipToStreet: detailData.shipToStreet,
        shipToDistrict: detailData.shipToDistrict,
        shipToPostalCode: detailData.shipToPostalCode,
        shipToCity: detailData.shipToCity,
        shipToCountry: detailData.shipToCountry,
        shipToRegion: detailData.shipToRegion,
        shipToTel: detailData.shipToTel,
        shipToEmail: detailData.shipToEmail,
        purchaseDate: detailData.purchaseDate,
        billingType: detailData.billingType,
        billingDate: detailData.billingDate,
        distributionChannel: detailData.distributionChannel,
        distributionChannelName: detailData.distributionChannelName,
        division: detailData.division,
        divisionName: detailData.divisionName,
        materialNo: detailData.materialNo,
        unitPrice: detailData.unitPrice,
        movingAveragePrice: detailData.movingAveragePrice,
      };
      if ([CdAction.PUMI, CdAction.PROCESS].includes(action)) {
        billingDataInput = {
          ...billingDataInput,
          poNo: detailData.poNo,
          poDate: detailData.poDate,
          reqDeliDate: detailData.reqDeliDate,
          remark: detailData.remark,
        }
      }
      data = {
        ...data,
        billingDataInput,
      }
    }
    if (detailData.panelUsageHours) {
      const regex = /^-?(0|[1-9]\d*)?$/;
      const na = ['n/a', 'na'];
      const panelUsageHoursString = detailData.panelUsageHours.toString().toUpperCase();
      if (!regex.test(detailData.panelUsageHours) && !na.includes(panelUsageHoursString.toLowerCase())) {
        this.form.panelUsageHours.markAsTouched();
        this.form.panelUsageHours.setErrors({ pattern: 'It\'s invalid value, only allowed number or \'N/A\'' });
        return;
      }
      data.panelUsageHours = panelUsageHoursString;
    }
    // agent
    if (this.roles.cdReviewer.includes(this.userType) || this.hasCdAgentRole) {
      if (this.detailForm.invalid) {
        this.detailForm.markAllAsTouched();
        return false;
      }
      delete data.status;
      data = {
        ...data,
        returnReason: detailData.returnReason,
        subReason: detailData.subReason,
        contactEmail: detailData.contactEmail,
        packaging: detailData.packaging,
        appearance: detailData.appearance,
        accessory: detailData.accessory,
        func: detailData.func,
        defectDetail: detailData.defectDetails,
        rejectReason: detailData.rejectionReason,
      };
      if (this.creatorType === this.creatorTypes.ussi) {
        const address = this.locationAliases?.find(la => la._id === detailData.customer)?.address;
        data = {
          ...data,
          customer: detailData.customer,
          address,
        };
      }
      if (this.creatorType === this.creatorTypes.cd) {
        detailData = this.valueRedefinition(detailData);
        if (this.detailForm.invalid || this.googlePlacesAutocomplete.validAddress(detailData.address)) {
          this.googlePlacesAutocomplete.isAddressValid$.next(true);
          this.detailForm.markAllAsTouched();
          return false;
        }
        this.googlePlacesAutocomplete.isAddressValid$.next(false);
        data = {
          ...data,
          firstName: detailData.firstName,
          lastName: detailData.lastName,
          cellPhone: detailData.cellPhone,
          email: detailData.email,
          address: detailData.address,
        };

      }
      return data;
    }
    // USSI
    if (this.roles.ussi.includes(data.creationType)) {
      if (this.detailForm.invalid) {
        this.detailForm.markAllAsTouched();
        return false;
      }
      const address = this.locationAliases?.find(la => la._id === detailData.customer)?.address;

      data = {
        ...data,
        customer: detailData.customer,
        address,
        contactEmail: detailData.contactEmail,
        packaging: detailData.packaging,
        appearance: detailData.appearance,
        accessory: detailData.accessory,
        func: detailData.func,
      };
    } else {
      //cd-dealer
      detailData = this.valueRedefinition(detailData);
      if (this.detailForm.invalid || this.googlePlacesAutocomplete.validAddress(detailData.address)) {
        this.googlePlacesAutocomplete.isAddressValid$.next(true);
        this.detailForm.markAllAsTouched();
        return false;
      }
      this.googlePlacesAutocomplete.isAddressValid$.next(false);
      data = {
        ...data,
        firstName: detailData.firstName,
        lastName: detailData.lastName,
        cellPhone: detailData.cellPhone,
        email: detailData.email,
        address: detailData.address,
      };

    }

    return data;
  }

  submitForm($event, action?) {
    $event.stopPropagation();
    $event.preventDefault();
    const data = this.getSaveDefaultData(action);
    if (!data) {
      Swal.fire({
        title: 'Please fill out the required fields.',
        icon: 'error',
      });
      return;
    }
    if (this.ticketNo && !action) {
      this.updateDetail($event, CdAction.DRAFT);
      return;
    }
    Object.keys(data).forEach(key => {

      if (this.formData.get(key)) {
        this.formData.delete(key);
      }
      const value = key === 'address' ? JSON.stringify(data[key]) : data[key];
      this.formData.append(key, value);
    })

    if (this.formData.get('billingData')) {
      this.formData.delete('billingData');
    }
    if (this.billingData) {
      this.formData.append('billingData', JSON.stringify(this.billingData));
    }

    this.spinnerService.start();
    this.apiService.concealedDamage.createConcealedDamage(this.formData)
      .subscribe(res => {

        if (res?.status === 200 && res?.body) {
          this.spinnerService.stop();

          Swal.fire({
            title: 'Ticket created successfully.',
            text: '',
            icon: 'success',
            allowOutsideClick: false,
          });

          this.isNew = false;
          const { contactEmail } = data;
          const { ticketNo } = res.body;
          this.ticketNo = ticketNo;
          const dealerType = contactEmail ? 'ussi' : 'cd';
          let appendUrl = dealerType.concat('/', ticketNo);
          this.location.replaceState(`/concealed-damage/detail/${ appendUrl }`);
          this.creatorType = this.roles.ussi.includes(this.userType) ? this.creatorTypes.ussi : this.creatorTypes.cd;
          this.detailForm.reset();
          this.getConcealedDamage();
        }

      }, err => {
        this.spinnerService.stop();
        Utils.showError(err)
      });

  }

  updateProcess(type, data?) {
    let title;
    let submitBtn;
    switch (type) {
      case 'PROCESS':
        title = 'Approve';
        submitBtn = !this.isMobile ? 'Save & Approve' : 'Save';
        break;
      case 'PUMI':
        title = 'PUMI Approve';
        submitBtn = !this.isMobile ? 'Save & Approve' : 'Save';
        break;
      case 'REJECT':
        title = 'Reject';
        submitBtn = !this.isMobile ? 'Save & Reject' : 'Save';
        break;
    }


    let initialState: any = {
      type,
      title,
      submitBtn,
      initInfo: this.initInfo,
      reasonOptions: this.approvalReasonOptions,
      data
    };

    if (data) {
      const { returnReason, subReason, rejectionReason } = data;
      initialState.cdData = { returnReason, subReason, rejectionReason };
    }

    this.bsModalRef = this.modalService.show(ConcealedDamageDetailActionsComponent, { initialState });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.detailForm.reset();
        this.getConcealedDamage();
      }
    });
  }

  reject($event) {
    $event.stopPropagation();
    $event.preventDefault();

  }

  approve($event) {

  }

  updateDetail($event, action) {
    $event.stopPropagation();
    $event.preventDefault();
    if (action === CdAction.REVIEW && !this.ticketNo) {
      this.submitForm($event, action);
      return;
    }
    if ([CdAction.PROCESS, CdAction.PUMI].includes(action)) {
      this.form.rejectionReason.setErrors(null);
    }
    if ([CdAction.REJECT, CdAction.SAVE].includes(action)) {
      this.form.returnReason.setErrors(null);
      this.form.subReason.setErrors(null);
    }

    const currentStatus = _.cloneDeep(this.detailInfo.status);
    let data = null;
    switch (action) {
      case CdAction.REVIEW:
      case CdAction.DRAFT:
      case CdAction.SAVE:
        data = this.getSaveDefaultData();
        if (!data) {
          return;
        }
        break;
      case CdAction.REJECT:
        data = this.getSaveDefaultData();
        if (!data) {
          return;
        }
        if (!data.rejectionReason || Utils.stringToNull(data.rejectionReason) === null) {
          this.form.rejectionReason.markAsTouched();
          this.form.rejectionReason.setErrors({ required: true });
          return;
        }
        this.updateProcess(action, data);
        return;
        break;
      case CdAction.PROCESS:
      case CdAction.PUMI:
        data = this.getSaveDefaultData(action);
        if (!data) {
          return;
        }
        if (!data.returnReason || Utils.stringToNull(data.returnReason) === null) {
          this.form.returnReason.markAsTouched();
          this.form.returnReason.setErrors({ required: true });
          return;
        }
        if (!data.subReason || Utils.stringToNull(data.subReason) === null) {
          this.form.subReason.markAsTouched();
          this.form.subReason.setErrors({ required: true });
          return;
        }
        // if (!this.files.length || !this.files[0]?.fieldname) {
        //   this.openErrorMessage(`Please file attachment fields check.`)
        //   return;
        // }
        this.updateProcess(action, data);
        return;
        break;
      case CdAction.COMPLETE:
        data = {};
        break;
      case CdAction.DELETE:
        this.deleteConcealedDamage(this.ticketNo);
        return;
        break;
      default:
        break;
    }
    data.status = action === CdAction.SAVE ? 'REVIEW' : action;
    this.spinnerService.start();
    this.apiService.concealedDamage.saveConcealedDamage(data, this.ticketNo)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        if (!(currentStatus === 'REVIEW' && action === 'DRAFT')) {
          Swal.fire({
            title: 'Ticket updated successfully.',
            text: '',
            icon: 'success',
            allowOutsideClick: false,
          });
        }

        this.detailForm.reset();
        this.getConcealedDamage();

      }, err => Utils.showError(err));
  }


  openErrorMessage(message?) {
    Swal.fire({
      icon: 'error',
      title: message || `Please errors check.`,
      showConfirmButton: true,
    });
  }


  deleteConcealedDamage(ticketNo) {
    Swal.fire({
      title: 'Request data will be deleted. Do you want to continue?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        this.apiService.concealedDamage.deleteConcealedDamage(ticketNo)
          .subscribe(res => {
            Swal.fire('Deleted!', '', 'success').then(() => {
              this.router.navigateByUrl('/concealed-damage');
            });
          }, err => Utils.showError(err));
      } else if (result.isDenied) {
        Swal.fire('Canceled!', '', 'info');
      }
    });
  }

  fileDownload(ticketNo, targetType) {
    const fileName = `${ ticketNo }-${ targetType.toUpperCase() }-${ DateUtils.toHqMomentFormat(new Date(), 'YYYYMMDDHHmmssSSS') }`;
    this.fileService.downloadFile(this.backend.concat(`/concealed-damage/${ this.detailInfo.ticketNo }/files/download?targetType=${ targetType }`), fileName);
  }

  toggleBillingData() {
    this.showBillingData = !this.showBillingData;
  }

  modalOpen() {
    this.bsModalRef = this.modalService.show(ConcealedDamageDetailQuestionComponent, { class: 'modal-dialog modal-dialog-centered' });
  }

}

